




































































































































































import { Component, Mixins, Provide, Watch } from 'vue-property-decorator';
import MixinResults from '@/plugins/podolib/services/helper/mixins/results';
import { get } from 'lodash';
// Components
import ChartRunningPhaseGlobalBanner from '@/components/charts/running/ChartRunningPhaseGlobalBanner.vue';
import ChartRunningPhaseAsymmetry from '@/components/charts/running/ChartRunningPhaseAsymmetry.vue';
import ChartRunningPhaseStrikePattern from '@/components/charts/running/ChartRunningPhaseStrikePattern.vue';
import ChartRunningPhaseAdvancedStrikePattern from '@/components/charts/running/ChartRunningPhaseAdvancedStrikePattern.vue';
import ChartRunningPhaseSpeedCadence from '@/components/charts/running/ChartRunningPhaseSpeedCadence.vue';
import ChartRunningPhaseRunSteps from '@/components/charts/running/ChartRunningPhaseRunSteps.vue';
import ChartRunningPhaseAngles from '@/components/charts/running/ChartRunningPhaseAngles.vue';
import ChartRunningPronationSupinationAngles from '@/components/charts/running/CharRunningPronationSupinationAngles.vue';
import ElementBlocInterpretation from '@/components/elements/ElementBlocInterpretation.vue';
import PatientAcquisitionComments from '@/components/patients/PatientAcquisitionComments.vue';
import ElementResultsTooltip from '@/components/elements/ElementResultsTooltip.vue';
import ElementInterpretationManualBanner from '@/components/elements/ElementInterpretationManualBanner.vue';

@Component({
  components: {
    ChartRunningPhaseGlobalBanner,
    ChartRunningPhaseAsymmetry,
    ChartRunningPhaseStrikePattern,
    ChartRunningPhaseAdvancedStrikePattern,
    ChartRunningPhaseSpeedCadence,
    ChartRunningPhaseRunSteps,
    ChartRunningPhaseAngles,
    ChartRunningPronationSupinationAngles,
    ElementBlocInterpretation,
    PatientAcquisitionComments,
    ElementResultsTooltip,
    ElementInterpretationManualBanner,
  },
})
export default class PatientsResultsRunningGlobal extends Mixins(MixinResults) {
  advancedMode = false;
  relativeMode = false;

  get isNewAnalysis() {
    return this.$pdc.helper?.isNewAnalysis(this.acquisition.computed_data);
  }
  get acquisitionTreadmill() {
    let speed = !!this.acquisition.data.treadmill_speed;
    return speed ? this.acquisition.data.treadmill_speed : speed;
  }
  get acquisitionInfos() {
    return {
      type: this.acquisition.analysisType,
      data: this.acquisition.data,
    };
  }
}
